module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comment-toolbar clearfix"
  }, [_c('div', {
    staticClass: "toolbar-text"
  }, [_c('a', {
    attrs: {
      "href": _vm.markdownDocs,
      "target": "_blank",
      "tabindex": "-1"
    }
  }, [_vm._v("\n      Markdown is supported\n    ")])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "toolbar-button markdown-selector",
    attrs: {
      "type": "button",
      "tabindex": "-1"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-image-o toolbar-button-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n    Attach a file\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-319f0f0c"}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/markdown/toolbar.vue
// module id = ../../../node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-319f0f0c"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/markdown/toolbar.vue
// module chunks = common_vue